<template>
    <v-card>
        <v-toolbar color="secondary" dense dark>
            <v-spacer></v-spacer>
            <v-toolbar-title>
                Rates
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                dark
                icon
                left
                @click="$store.state.transacting.dialogRate = false"
                ><v-icon>mdi-close</v-icon></v-btn
            >
        </v-toolbar>
        <v-container grid-list-xs fluid>
            <v-card>
                <v-toolbar color="primary" dark dense elevation-1>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>
                        Station: {{ stationName }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row>
                    <v-col cols="3">
                        <v-card>
                            <v-data-table
                                dense
                                :headers="hearderTerminal"
                                :items="rate"
                                hide-actions
                                hide-default-footer
                                class="elevation-1"
                            >
                                <template v-slot:top>
                                    <v-toolbar color="light" dense>
                                        <v-spacer />
                                        <v-toolbar-title
                                            >Terminals</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                    <v-col cols="5">
                        <v-card>
                            <v-data-table
                                dense
                                :headers="header"
                                :items="rate"
                                hide-default-footer
                                class="elevation-1"
                            >
                                <template v-slot:top>
                                    <v-toolbar color="light" dense>
                                        <v-spacer />
                                        <v-toolbar-title
                                            >Invoice</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                    <v-col cols="4">
                        <v-card>
                            <v-data-table
                                dense
                                :headers="hearderPayroll"
                                :items="rate"
                                hide-actions
                                hide-default-footer
                                class="elevation-1"
                            >
                                <template v-slot:top>
                                    <v-toolbar color="light" dense>
                                        <v-spacer />
                                        <v-toolbar-title
                                            >Payroll</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
    </v-card>
</template>
<script>
import axios from 'axios';
export default {
    props: ['dataInfo'],
    data: function() {
        return {
            stationName: '',
            station: {},
            rate: [],
            header: [
                { text: 'Dies Rate', value: 'InvRate', width: '5%' },
                { text: 'Gas Rate', value: 'InvGasRate', width: '5%' },
                { text: 'Flat Rate', value: 'InvFlat', width: '5%' },
                { text: 'BH Rate', value: 'InvBHRate', width: '5%' },
                { text: 'BH Flat', value: 'InvBHFlat', width: '5%' }
                // { text: 'Rate Type', value: 'Type', width: '5%' },
            ],
            hearderPayroll: [
                { text: 'KMS', value: 'Kms', width: '20%' },
                { text: ' OO GasRate', value: 'OObyLitre', width: '40%' },
                { text: ' OO DiesRate', value: 'OObyLitreDiesel', width: '40%' }
            ],

            hearderTerminal: [
                {
                    text: 'Terminal',
                    value: 'terminal.TerminalName',
                    width: '100%'
                }
            ]
        };
    },

    mounted() {
        console.log(this.dataInfo);
        this.getShiftDetails();
    },
    methods: {
        getShiftDetails: function() {
            var str = this.$store;
            axios
                .get('order/' + this.dataInfo.OrderNumber)
                .then(response => {
                    this.station = response.data;
                    console.log(this.station);
                    this.getRates();
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });

                        str.state.isLoading = false;
                    }
                });
        },
        getRates: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('new-rate/st/' + this.station.Station)
                .then(response => {
                    this.rate = response.data;
                    console.log(this.rate);
                    str.state.isLoading = false;
                    this.stationName = this.rate[0].station.Name;
                    this.rate.forEach(element => {
                        if (element.Terminal == null || element.Terminal == 0) {
                            element.terminal = {
                                TerminalName: 'Null',
                                TerminaID: ''
                            };
                        }
                    });
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });

                        str.state.isLoading = false;
                    }
                });
            this.$store.state.isLoading = false;
        }
    }
};
</script>
